import React, { useState, useEffect } from 'react';
import { GetList, UpdateEntry, DeleteEntry } from '../../providers/dataProvider';
import userImage from '../../assets/images/userImage.png';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

const Notification = ({ onNotificationRead }) => {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState(null);
    const [archivedNotifications, setArchivedNotifications] = useState(null);
    const [activeTab, setActiveTab] = useState('latest');
    const [readMsg, setReadMsg] = useState(null);
    const [readAllMsg, setReadAllMsg] = useState(null);
    const [actionMsg, setActionMsg] = useState(null);

    const cleanupModalBackdrop = () => {
        document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('padding-right');
    };

    const closeNotificationDrawer = () => {
        const modal = window.document.getElementById('notificationRightSideModalPopup');
        if (modal) {
            modal.classList.remove('show');
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
            modal.removeAttribute('aria-modal');
        }
        cleanupModalBackdrop();
    };

    const fetchNotifications = () => {
        GetList("notificationlatest", {
            pageNumber: 1,
            pageSize: 10,
        }, (res) => {
            setNotifications(res);
        });
    };

    const fetchArchivedNotifications = () => {
        GetList("notificationarchivelist", {
            pageNumber: 1,
            pageSize: 10,
        }, (res) => {
            setArchivedNotifications(res);
        });
    };

    const markAsRead = (id) => {
        UpdateEntry(
            "notificationread",
            { id: id },
            setReadMsg,
            "Marked as read successfully",
            "Failed to mark as read"
        );
    };

    const markAllAsRead = () => {
        UpdateEntry(
            "notificationreadall",
            {},
            setReadAllMsg,
            "All marked as read successfully",
            "Failed to mark all as read"
        );
    };

    const archiveNotification = (id, e) => {
        e.stopPropagation();
        e.preventDefault();
        UpdateEntry(
            "notificationarchive",
            { id },
            setActionMsg,
            "Archived successfully",
            "Failed to archive"
        );
    };

    const deleteNotification = (id, e) => {
        e.stopPropagation();
        e.preventDefault();
        DeleteEntry(
            "notificationdelete",
            { id },
            setActionMsg,
            "Deleted successfully",
            "Failed to delete"
        );
    };

    const handleNotificationClick = (notification) => {
        if (!notification.isRead) {
            markAsRead(notification?.id);

            const updater = (prev) => ({
                ...prev,
                data: {
                    ...prev?.data,
                    payload: prev?.data?.payload?.map(n =>
                        n.id === notification.id ? { ...n, isRead: true } : n
                    )
                }
            });

            if (activeTab === 'archived') {
                setArchivedNotifications(updater);
            } else {
                setNotifications(updater);
            }
        }

        closeNotificationDrawer();

        if (notification?.referenceId) {
            navigate('/job-in-hand', {
                state: {
                    id: notification?.referenceId,
                    initialTab: "Details",
                    initialProductTab: "ProductList"
                }
            });
        }
    };

    useEffect(() => {
        if (readMsg?.status === 204 || readMsg?.status === 200) {
            fetchNotifications();
            onNotificationRead?.();
        }
    }, [readMsg]);

    useEffect(() => {
        if (readAllMsg?.status === 204 || readAllMsg?.status === 200) {
            fetchNotifications();
            onNotificationRead?.();
        }
    }, [readAllMsg]);

    useEffect(() => {
        if (actionMsg?.status === 204 || actionMsg?.status === 200) {
            fetchNotifications();
            if (activeTab === 'archived') fetchArchivedNotifications();
            onNotificationRead?.();
        } else if (actionMsg?.status === 400) {
            const errorMsg = actionMsg?.successData?.errors?.[0]?.message
                || "Action failed. Please try again.";
            toast.error(errorMsg);
        }
    }, [actionMsg]);

    useEffect(() => {
        fetchNotifications();
    }, []);

    useEffect(() => {
        const modal = window.document.getElementById('notificationRightSideModalPopup');
        if (!modal) return undefined;

        modal.addEventListener('hidden.bs.modal', cleanupModalBackdrop);
        return () => modal.removeEventListener('hidden.bs.modal', cleanupModalBackdrop);
    }, []);

    useEffect(() => {
        if (activeTab === 'archived') fetchArchivedNotifications();
    }, [activeTab]);

    const displayList = activeTab === 'latest'
        ? notifications?.data?.payload
        : archivedNotifications?.data?.payload;

    return (
        <>
            <div className="modal fade drawer right-align" id="notificationRightSideModalPopup" tabIndex="-1" role="dialog"
                aria-labelledby="notificationRightSideModalPopupLabel" data-backdrop="false">
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        <div className="header">
                            <div className='d-flex justify-content-between'>
                                <h5 id="notificationRightSideModalPopupLabel">Notifications</h5>
                                <button
                                    className="notification-close-btn"
                                    type="button"
                                    data-dismiss="modal"
                                    onClick={closeNotificationDrawer}
                                    aria-label="Close notifications"
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body">

                            {/* Tabs */}
                            <div className='row mt-2'>
                                <div className='col-md-12'>
                                    <div className='d-flex' style={{ borderBottom: '2px solid #eee' }}>
                                        <h6
                                            style={{
                                                cursor: 'pointer',
                                                marginRight: '20px',
                                                paddingBottom: '8px',
                                                borderBottom: activeTab === 'latest' ? '2px solid #007bff' : 'none',
                                                color: activeTab === 'latest' ? '#007bff' : '#666'
                                            }}
                                            onClick={() => setActiveTab('latest')}
                                        >
                                            Latest
                                        </h6>
                                        <h6
                                            style={{
                                                cursor: 'pointer',
                                                paddingBottom: '8px',
                                                borderBottom: activeTab === 'archived' ? '2px solid #007bff' : 'none',
                                                color: activeTab === 'archived' ? '#007bff' : '#666'
                                            }}
                                            onClick={() => setActiveTab('archived')}
                                        >
                                            Archived
                                        </h6>
                                    </div>
                                </div>
                            </div>

                            {/* Mark all / Clear all - Latest tab only */}
                            {activeTab === 'latest' && (
                                <div className='row mt-3'>
                                    <div className='col-md-12'>
                                        <div className='clear-all-area'>
                                            <h6 style={{ cursor: 'pointer' }} onClick={markAllAsRead}>
                                                Mark all as read
                                            </h6>
                                            <p style={{ cursor: 'pointer' }}>Clear all</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Notification List */}
                            <div className='row mt-3'>
                                {!displayList?.length && (
                                    <div className='col-md-12 text-center mt-3'>
                                        {activeTab === 'archived' ? (
                                            <p>No archived</p>
                                        ) : (
                                            <p>No notifications</p>
                                        )}
                                    </div>
                                )}
                                {displayList?.map((notification) => (
                                    <div className='col-md-12' key={notification.id}>
                                        <div
                                            className={`${notification.isRead ? 'read-message-area' : 'unread-message-area'} mb-2`}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleNotificationClick(notification)}
                                        >
                                            <div className='message-content-area'>
                                                <div className='mr-3 ml-2'>
                                                    <img src={userImage} className="user-img" alt="user" />
                                                </div>
                                                <div className='mr-3'>
                                                    <h5>
                                                        {notification.title}
                                                        <span className='float-right'>
                                                            {activeTab === 'latest' && (
                                                                notification.category?.toLowerCase() === 'approval' ? (
                                                                    <i
                                                                        className="fas fa-archive"
                                                                        title="Archive"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={(e) => archiveNotification(notification.id, e)}
                                                                    ></i>
                                                                ) : (
                                                                    <i
                                                                        className="far fa-trash-alt"
                                                                        title="Delete"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={(e) => deleteNotification(notification.id, e)}
                                                                    ></i>
                                                                )
                                                            )}
                                                        </span>
                                                    </h5>
                                                    <h6>
                                                        {notification.category}-
                                                        <span> {notification.message}</span>
                                                    </h6>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notification;
